import { Alert, Button, message } from 'antd'
import { EyeOutlined, CloseOutlined } from '@ant-design/icons'
import { useImpersonationStore } from '@/store/impersonation'

export function ImpersonationBanner() {
  const { impersonatedOrgId, impersonatedOrgName, stopImpersonation } = useImpersonationStore()

  if (!impersonatedOrgId) return null

  const handleStop = async () => {
    try {
      await stopImpersonation()
    } catch {
      message.error('Не удалось выйти из режима просмотра')
    }
  }

  return (
    <Alert
      type="warning"
      showIcon
      icon={<EyeOutlined />}
      message={
        <span>
          Рабочий контекст ЛПУ:{' '}
          <strong>{impersonatedOrgName || 'Организация'}</strong>
        </span>
      }
      description="Справочники, структура, коечный фонд, реквизиты и загрузки выполняются для выбранной организации."
      action={
        <Button
          size="small"
          type="text"
          icon={<CloseOutlined />}
          onClick={handleStop}
          style={{ color: '#faad14' }}
        >
          Сбросить контекст
        </Button>
      }
      style={{
        borderRadius: 0,
        borderLeft: 'none',
        borderRight: 'none',
        borderTop: 'none',
      }}
    />
  )
}
